import { render, staticRenderFns } from "./bonus.vue?vue&type=template&id=570f67e9&"
import script from "./bonus.vue?vue&type=script&lang=js&"
export * from "./bonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports